export function statusTextForSale(sale: sage.model.ISale): string {
    switch (sale.state) {
        case "ERROR":
            return "Error";
        case "CANCELLED":
            return "Cancelled";
        case "FINISHED":
            return "Finished";
        case "PARTIALLY_FINISHED":
            return "Partially Finished";
        case "QUEUED":
            return "In Queue";
        case "NO_AVAILABLE_ORDERS":
            return "No Available Orders";
    }
}

export function colorClassForSale(sale: sage.model.ISale): string {
    switch (sale.state) {
        case "QUEUED":
        case "CANCELLED":
            return "secondary";
        case "PARTIALLY_FINISHED":
            return "primary";
        case "FINISHED":
            return "success";
        case "ERROR":
            return "danger";
        case "NO_AVAILABLE_ORDERS":
            return "warning";
    }
}
